import "core-js/modules/es6.array.find";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { JeecgListMixin } from '@/mixins/JeecgListMixin';
import { getAction } from '@/api/manage';
export default {
  name: "CarRepairItemModal",
  mixins: [JeecgListMixin],
  data: function data() {
    return {
      title: '选择保险险种',
      visible: false,
      autoLoadInit: false,
      disableSubmit: false,
      model: {},
      columns: [{
        title: '保险险种',
        dataIndex: 'category_dictText',
        align: 'center',
        width: '20%',
        scopedSlots: {
          customRender: 'category'
        }
      }, {
        title: '绝对免赔率',
        dataIndex: 'deductible',
        align: 'center',
        width: '15%',
        scopedSlots: {
          customRender: 'deductible'
        }
      }, {
        title: '费率浮动',
        dataIndex: 'rate',
        align: 'center',
        width: '15%',
        scopedSlots: {
          customRender: 'rate'
        }
      }, {
        title: '保险金额/责任限额',
        dataIndex: 'worth',
        align: 'center',
        width: '15%',
        scopedSlots: {
          customRender: 'worth'
        }
      }, {
        title: '保险费',
        dataIndex: 'fee',
        align: 'center',
        width: '15%',
        scopedSlots: {
          customRender: 'fee'
        }
      }],
      url: {
        list: '/asset/car/insurance/queryInsuranceItem/'
      }
    };
  },
  props: ['pagePath'],
  created: function created() {},
  methods: {
    show: function show(carId) {
      var _this = this;

      this.visible = true;
      this.loading = true;
      this.selectedRowKeys = [];
      getAction(this.url.list + carId).then(function (res) {
        if (res.success) {
          var list = [];

          for (var i = 0; i < res.result.length; i++) {
            var insurance = res.result[i];
            list.push(insurance);
          }

          _this.dataSource = list;
        } else {
          _this.$message.warning('系统异常=>' + res.message);
        }

        _this.loading = false;
      });
    },
    close: function close() {
      this.$emit('close');
      this.visible = false;
    },
    handleOk: function handleOk() {
      this.close();
    },
    handleCancel: function handleCancel() {
      this.close();
    },
    handleSelect: function handleSelect() {
      var _this2 = this;

      if (this.selectedRowKeys.length <= 0) {
        this.$message.warning('请选择一种险种！');
        return;
      }

      var _loop = function _loop(i) {
        var insurance = _this2.dataSource.find(function (item) {
          return item.id === _this2.selectedRowKeys[i];
        });

        insurance.key = 'A' + _this2.addPayDataIndex;
        insurance.amount = 1;

        _this2.$emit('selectInsurance', insurance);
      };

      for (var i = 0; i < this.selectedRowKeys.length; i++) {
        _loop(i);
      }

      this.close();
    }
  }
};